export default "__VITE_ASSET__DU4nGU30__"